import {DataStorageData, Dealer} from './shared/types';

export function mapBffDealerToUiDealer(bffDealer: DataStorageData['dealerData']): Dealer {
  return {
    id: bffDealer.volkswagenGroupPartnerIds[0],
    name: bffDealer.companyName,
    street: bffDealer.addresses[0].street,
    zip: bffDealer.addresses[0].zipCode,
    city: bffDealer.addresses[0].city,
    houseNumber: bffDealer.addresses[0].houseNumber,
    phone: bffDealer.contactData.mobilePhoneNumber
      ? `${bffDealer.contactData.mobilePhoneCountryCode || ''}${bffDealer.contactData.mobilePhoneNumber}`
      : `${bffDealer.contactData.telephoneCountryCode || ''}${bffDealer.contactData.telephoneNumber}`,
    email: bffDealer.contactData.emails?.[0]?.emailAddress
  };
}
